import Link from 'next/link'

import { Button } from '@/_components/ui/button'

const Success = () => {
  return (
    <Button asChild className="w-full">
      <Link href="/dashboard/login">Acessar a plataforma</Link>
    </Button>
  )
}

export default Success
